<template>
  <ion-card ref="card" class="ion-margin" v-if="value" v-motion>
    <ion-card-header>
      <ion-card-subtitle>
        {{ subTitle }}
      </ion-card-subtitle>
      <ion-card-title>
        {{ title }}
      </ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <div class="card-main">
        <div ref="valueTarget">{{ data }}{{ valueSuffix }}</div>
        <ion-icon :icon="icon" />
      </div>
      <div class="card-footer">{{ additionalInfo }}</div>
    </ion-card-content>
    <canvas id="card"></canvas>
  </ion-card>
</template>

<script setup lang="ts">
import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonIcon } from "@ionic/vue";
import { defineProps, onMounted, ref, watch } from "vue";
import { useMotion } from "@vueuse/motion";
import { useElementVisibility } from '@vueuse/core'

const props = defineProps({
  subTitle: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: false
  },
  value: {
    type: String || Number,
    required: true
  },
  icon: {
    type: String,
    required: false
  },
  additionalInfo: {
    type: String,
    required: false
  }
})

let displayValue = ref(0)
let valueSuffix = ref("")
const card = ref()
let data = ref(0)
const valueTarget = ref(null)
const valueTargetIsVisible = useElementVisibility(valueTarget)

onMounted(() => {
  const val = props.value.includes(",") ? props.value.replaceAll(",", "") : props.value

  if(val.includes("+")) {
    valueSuffix.value = "+"
    displayValue.value = +val.replace("+", "")
  } else {
    displayValue.value = +val
  }
})

watch(valueTargetIsVisible, async() => {
  let interval = {} as any;
  if(valueTargetIsVisible.value) {
    interval = setInterval(() => {
      if(displayValue.value > data.value) {
        // To have similar effect for animation on all values
        displayValue.value - data.value > 2000 ? data.value += 200 :
        displayValue.value - data.value > 1000 ? data.value += 100 :
        displayValue.value - data.value > 500 ? data.value += 50 :
        displayValue.value - data.value > 100 ? data.value += 10 : data.value++;
      }
      else clearInterval(interval);
    }, 2)
  } else {
    clearInterval(interval);
    data.value = 0
  }
})

const { variant } = useMotion(card, {
  initial: {
    opacity: 0,
    y: 100
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 300,
      type: 'keyframes',
      ease: 'easeIn'
    },
  }
})
</script>

<style scoped>
canvas {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}
</style>